import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  styled,
} from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import colors from 'styles/application/_base/_variables.scss';

export const ForwardFormControl = styled(FormControl)`
  margin-bottom: 26px;
  width: 100%;
`;

export const ForwardGrid = styled(Grid)`
  padding-left: 12px;
`;

export const PhoneNumberText = styled(TextField)`
  label.MuiInputLabel-root.MuiInputLabel-formControl {
    font-weight: 700;
    letter-spacing: 0.035rem !important;
    color: #758ba3 !important;
  }
  .MuiInput-root.MuiInputBase-root {
    margin-top: 0px;
  }
  .MuiInput-input.MuiInputBase-input {
    padding: 8px 16px;
  }
  .MuiInputBase-root.Mui-disabled {
    color: ${colors.disabled};
    background-color: ${colors.disabledBg};
  }
`;

export const UnansweredSeconds = styled(TextField)`
  .MuiInputBase-formControl {
    width: 60px;
  }
  .MuiInputBase-root.Mui-disabled {
    color: ${colors.disabled};
    background-color: ${colors.disabledBg};
  }
`;

export const CallForwardGrid = styled(Grid)`
  padding: 0 0 0 22px;
`;

export const RadioGrp = styled(RadioGroup)`
  flex-direction: row;
  .MuiRadio-root {
    color: ${colors.secondaryColor};
    border-radius: 50%;
  }
  .MuiRadio-colorSecondary.Mui-checked {
    color: ${colors.primaryBlue};
  }
  .MuiIconButton-root {
    padding: 9px;
  }
  .MuiIconButton-colorSecondary:hover {
    background-color: ${colors.primaryColorHover};
  }
  .MuiTypography-body1 {
    font-size: ${pxToRem('14px')};
  }
`;

// .MuiButtonBase-root is a fix for styles being reordered on dev
export const RadioBtn = styled(Radio)`
  &.MuiButtonBase-root {
    position: relative;
    opacity: 1;
  }
`;

export const Label = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-family: Lato, sans-serif;
    font-size: ${pxToRem('14px')};
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.21px;
  }
`;
